
const getPartners = () => {
  const partners = localStorage.getItem("partners")
    ? JSON.parse(localStorage.getItem("partners"))
    : null;
  return partners;
};

const InitialState = {
  partners: getPartners(),
};

const PartnersReducer = (state = InitialState, action) => {

  if (action.type === "Save_Partners") {
    const newState = {
      partners: action.payload,
    };

    localStorage.setItem("partners", JSON.stringify(action.payload));
    return newState;
  }

  //logout
  else if (action.type === "Remove_User") {
    localStorage.removeItem("partners");
    const newState = {
      partners: null
    };
    return newState;
  }

  return state;
};

export default PartnersReducer;
